"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isListeningRanges = isListeningRanges;
exports.mergeListeningRanges = mergeListeningRanges;
exports.listeningCoverage = listeningCoverage;
/** Normalized media ranges, independent of playback speed. Invalid ranges are rejected. */
function isListeningRanges(value) {
    return (Array.isArray(value) &&
        value.length <= 500 &&
        value.every((range) => Array.isArray(range) &&
            range.length === 2 &&
            typeof range[0] === "number" &&
            Number.isFinite(range[0]) &&
            typeof range[1] === "number" &&
            Number.isFinite(range[1]) &&
            range[0] >= 0 &&
            range[1] <= 1 &&
            range[1] > range[0]));
}
function mergeListeningRanges(ranges) {
    const merged = [];
    for (const [start, end] of [...ranges].sort((a, b) => a[0] - b[0])) {
        const last = merged[merged.length - 1];
        if (last && start <= last[1])
            last[1] = Math.max(last[1], end);
        else
            merged.push([start, end]);
    }
    return merged;
}
function listeningCoverage(ranges) {
    const merged = mergeListeningRanges(ranges);
    const fraction = merged.reduce((sum, range) => sum + range[1] - range[0], 0);
    // Allow only media-clock rounding at the two ends, never bridge skipped gaps.
    const complete = merged.length === 1 && merged[0][0] <= 0.001 && merged[0][1] >= 0.999;
    return { fraction, complete };
}
//# sourceMappingURL=listeningCoverage.js.map